

























import { Component, Vue } from 'vue-property-decorator'
import { BForm, BFormRow, BCol, BFormGroup, BFormInput, BFormSelect, BButton, BIconSearch, BIconArrowCounterclockwise, BFormSelectOption, BRow } from 'bootstrap-vue';
import ClientFilterOptions from '@/types/ClientFilterOptions'

@Component({
    components: {
        'b-form': BForm,
        'b-form-row': BFormRow,
        'b-row': BRow,
        'b-col': BCol,
        'b-form-group': BFormGroup,
        'b-form-input': BFormInput,
        'b-form-select': BFormSelect,
        'b-form-select-option': BFormSelectOption,
        'b-btn': BButton,
        'b-icon-search': BIconSearch,
        'b-icon-arrow-counterclockwise': BIconArrowCounterclockwise
    }
})
export default class ClientFilter extends Vue {
    clientStatuses: ClientStatus[] = [
        { value: null, text: 'clientStatus.selectClientStatus' },
        { value: true, text: 'clientStatus.yes' },
        { value: false, text: 'clientStatus.no' }
    ]

    filter: ClientFilterOptions = {
        sequenceOrName: null,
        isActive: true
    }

    filterList(resetFilter: boolean) {
        if (resetFilter) {
            this.filter.sequenceOrName = null;
            this.filter.isActive = true;
        }
        this.$emit('filter-list', this.filter);
    }
}

interface ClientStatus {
    value: boolean | null;
    text: string;
}
